export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true
};
export const PageName = '绿途转移列表';